import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export interface EntityDetailRowProps {
  icon?: React.ReactNode;
  label: string;
  children: React.ReactNode;
}

const EntityDetailRow: React.FC<EntityDetailRowProps> = ({ icon, label, children }) => (
  <Stack direction="row" alignItems="center" spacing={1.25} sx={{ minHeight: 30 }}>
    <Box
      sx={{
        width: 18,
        display: 'flex',
        justifyContent: 'center',
        color: 'text.secondary',
        flexShrink: 0,
        '& svg': { fontSize: 16 },
      }}
    >
      {icon}
    </Box>
    <Typography
      variant="body2"
      sx={{
        minWidth: 88,
        flexShrink: 0,
        fontWeight: 500,
        color: 'text.secondary',
        lineHeight: 1.4,
      }}
    >
      {label}
    </Typography>
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  </Stack>
);

export default EntityDetailRow;
